import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Loader } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import AppointmentTypeList from '../AppointmentTypeList/AppointmentTypeList.js';
import SelectedChoices from '../SelectedChoices/SelectedChoicesContainer.js';
import ToolTipPopUpModalContainer from '../ToolTipPopUpModal/ToolTipPopUpModalContainer.js';

const AppointmentTypes = (_param)=> {
    var { className , labels , appointmentTypes , appointmentTypeIcons , appointmentTypeToolTips , appointmentGlobalLabels , onClick , onClickToolTip , onCloseToolTip , loading =false , activeToolTip =null , AgeGroupSelector  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "appointmentTypes",
        "appointmentTypeIcons",
        "appointmentTypeToolTips",
        "appointmentGlobalLabels",
        "onClick",
        "onClickToolTip",
        "onCloseToolTip",
        "loading",
        "activeToolTip",
        "AgeGroupSelector"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('appointment-types', className)
    }), /*#__PURE__*/ React.createElement(ToolTipPopUpModalContainer, {
        toolTip: activeToolTip,
        isOpen: Boolean(activeToolTip),
        onModalClose: onCloseToolTip,
        className: "appointment-types__tooltip"
    }), /*#__PURE__*/ React.createElement(SelectedChoices, null), /*#__PURE__*/ React.createElement(Heading, {
        className: "appointment-types__heading",
        component: "h2",
        variant: "small"
    }, labels.heading), labels.description && /*#__PURE__*/ React.createElement(Text, {
        className: "appointment-types__description",
        variant: "body"
    }, labels.description), loading ? /*#__PURE__*/ React.createElement("div", {
        className: "appointment-types__loader"
    }, /*#__PURE__*/ React.createElement(Loader, null)) : /*#__PURE__*/ React.createElement(React.Fragment, null, AgeGroupSelector && /*#__PURE__*/ React.createElement(AgeGroupSelector, null), /*#__PURE__*/ React.createElement(AppointmentTypeList, {
        className: "appointment-types__list",
        appointmentTypes: appointmentTypes,
        appointmentTypeIcons: appointmentTypeIcons,
        appointmentTypeToolTips: appointmentTypeToolTips,
        appointmentGlobalLabels: appointmentGlobalLabels,
        onClick: onClick,
        onClickToolTip: onClickToolTip
    })));
};
var AppointmentTypes$1 = AppointmentTypes;

export { AppointmentTypes$1 as default };
//# sourceMappingURL=AppointmentTypes.js.map
